export default "__VITE_ASSET__z31ErHvv__"